import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import MotorReservaExtrasAPI from '../../api/motorReservaExtras';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getRecords(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getById: _state => id => {
    return _state.records.find(record => record.id === Number(id)) || {};
  },
};

export const actions = {
  get: async function getRecords({ commit }) {
    commit(types.SET_MOTOR_RESERVA_EXTRAS_UI_FLAG, { isFetching: true });
    try {
      const response = await MotorReservaExtrasAPI.get();
      commit(types.SET_MOTOR_RESERVA_EXTRAS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_MOTOR_RESERVA_EXTRAS_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createRecord({ commit }, data) {
    commit(types.SET_MOTOR_RESERVA_EXTRAS_UI_FLAG, { isCreating: true });
    try {
      const response = await MotorReservaExtrasAPI.create(data);
      commit(types.ADD_MOTOR_RESERVA_EXTRA, response.data);
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_MOTOR_RESERVA_EXTRAS_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateRecord({ commit }, { id, ...updateObj }) {
    commit(types.SET_MOTOR_RESERVA_EXTRAS_UI_FLAG, { isUpdating: true });
    try {
      const response = await MotorReservaExtrasAPI.update(id, updateObj);
      commit(types.EDIT_MOTOR_RESERVA_EXTRA, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_MOTOR_RESERVA_EXTRAS_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteRecord({ commit }, id) {
    commit(types.SET_MOTOR_RESERVA_EXTRAS_UI_FLAG, { isDeleting: true });
    try {
      await MotorReservaExtrasAPI.delete(id);
      commit(types.DELETE_MOTOR_RESERVA_EXTRA, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_MOTOR_RESERVA_EXTRAS_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_MOTOR_RESERVA_EXTRAS_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_MOTOR_RESERVA_EXTRAS]: MutationHelpers.set,
  [types.ADD_MOTOR_RESERVA_EXTRA]: MutationHelpers.create,
  [types.EDIT_MOTOR_RESERVA_EXTRA]: MutationHelpers.update,
  [types.DELETE_MOTOR_RESERVA_EXTRA]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
